(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6416],{

/***/ 70151:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyArray = __webpack_require__(278),
    shuffleSelf = __webpack_require__(73480);

/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return shuffleSelf(copyArray(array));
}

module.exports = arrayShuffle;


/***/ }),

/***/ 69877:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),

/***/ 25127:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shuffleSelf = __webpack_require__(73480),
    values = __webpack_require__(52628);

/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return shuffleSelf(values(collection));
}

module.exports = baseShuffle;


/***/ }),

/***/ 278:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 73480:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRandom = __webpack_require__(69877);

/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

module.exports = shuffleSelf;


/***/ }),

/***/ 69983:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayShuffle = __webpack_require__(70151),
    baseShuffle = __webpack_require__(25127),
    isArray = __webpack_require__(1469);

/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  var func = isArray(collection) ? arrayShuffle : baseShuffle;
  return func(collection);
}

module.exports = shuffle;


/***/ }),

/***/ 74565:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():0}(this,(function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=54)}({0:function(e,t){e.exports=__webpack_require__(67294)},1:function(e,t){e.exports=__webpack_require__(45697)},54:function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var n=i(r(1)),o=i(r(0)),u=["size"];function i(e){return e&&e.__esModule?e:{default:e}}function l(){return(l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function f(e,t){if(null==e)return{};var r,n,o=function(e,t){if(null==e)return{};var r,n,o={},u=Object.keys(e);for(n=0;n<u.length;n++)r=u[n],t.indexOf(r)>=0||(o[r]=e[r]);return o}(e,t);if(Object.getOwnPropertySymbols){var u=Object.getOwnPropertySymbols(e);for(n=0;n<u.length;n++)r=u[n],t.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(e,r)&&(o[r]=e[r])}return o}var c=function(e){var t=e.size,r=f(e,u);return o.default.createElement("svg",l({viewBox:"0 0 20 20",fill:"currentColor",width:t||"20",height:t||"20"},r),o.default.createElement("path",{d:"M8.53033 14.2478L8 13.7175L7.46967 14.2478C7.76256 14.5407 8.23744 14.5407 8.53033 14.2478ZM8 12.6569L4.53033 9.18718C4.23744 8.89429 3.76256 8.89429 3.46967 9.18718C3.17678 9.48008 3.17678 9.95495 3.46967 10.2478L7.46967 14.2478L8 13.7175L8.53033 14.2478L16.2478 6.53033C16.5407 6.23743 16.5407 5.76256 16.2478 5.46967C15.955 5.17677 15.4801 5.17677 15.1872 5.46967L8 12.6569Z",fill:"currentColor",fillRule:"evenodd",clipRule:"evenodd"}))};c.displayName="Check",c.propTypes={size:n.default.string},c.__docgenInfo={description:"",methods:[],displayName:"Check",props:{size:{type:{name:"string"},required:!1,description:""}}};var a=c;t.default=a}})}));

/***/ }),

/***/ 62414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ starsClusters; }
/* harmony export */ });
/* harmony import */ var constants_clusters__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16961);
/* harmony import */ var constants_clusters__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_clusters__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273);


var starsClusters = [
    {
        text: "Creative & design",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/design_icon.png",
        colorName: "sofia-pink",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.DESIGN_AND_CREATIVE
    },
    {
        text: "IT",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/it_icon.png",
        colorName: "purple-v2",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.IT
    },
    {
        text: "Software development",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/dev_icon.png",
        colorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DEV_GREEN_COLOR_NAME,
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.SOFTWARE
    },
    {
        text: "Marketing",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/marketing_icon.png",
        colorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.MARKETING_RED_COLOR_NAME,
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.MARKETING
    },
    {
        text: "Project management",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/pmo_icon.png",
        colorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.PROJECTS_ORANGE_COLOR_NAME,
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.GENERIC_CLUSTER,
        useCaseId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.PROJECT_MANAGEMENT_USE_CASE
    },
    {
        text: "Sales & CRM",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/crm_icon.png",
        colorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_GREEN_COLOR_NAME,
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.CRM
    },
    {
        text: "Task management",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/task_icon.png",
        colorName: "light-blue-v2",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.GENERIC_CLUSTER
    },
    {
        text: "HR",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/hr_icon.png",
        colorName: "sunset",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.HR
    },
    {
        text: "Operations",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/operations_icon.png",
        colorName: "aquamarine",
        clusterId: constants_clusters__WEBPACK_IMPORTED_MODULE_0__.OPERATIONS
    }
];
/* harmony default export */ __webpack_exports__["Z"] = ({
    tagsWidth: "140px",
    clusters: starsClusters,
    buttonConfig: {
        buttonColor: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.IRIS_COLOR_NAME
    }
});


/***/ }),

/***/ 76416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ PRESELECTED_TAG_PARAM_NAME; },
  "Z": function() { return /* binding */ square_tags; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./services/clusters-service.js
var clusters_service = __webpack_require__(90958);
// EXTERNAL MODULE: ./constants/clusters.js
var constants_clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/secondary-button.js + 1 modules
var secondary_button = __webpack_require__(95736);
// EXTERNAL MODULE: ./styles/colors-utils.js
var colors_utils = __webpack_require__(61012);
// EXTERNAL MODULE: ./client/services/hotjar-service/hotjar-service.js
var hotjar_service = __webpack_require__(96339);
// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./services/utils-service.js
var utils_service = __webpack_require__(20618);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/icons/Check.js
var Check = __webpack_require__(74565);
var Check_default = /*#__PURE__*/__webpack_require__.n(Check);
;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tag/components/tag-checkbox.js





var TagCheckbox = function(param) {
    var checkColor = param.checkColor, isSelected = param.isSelected, selectedBorderColor = param.selectedBorderColor, tagBorderColor = param.tagBorderColor, selectedBackgroundColor = param.selectedBackgroundColor;
    var checkboxColor = (0,react.useMemo)(function() {
        return checkColor && colors/* default */.Z[checkColor];
    }, [
        checkColor
    ]);
    var checkboxBorderColor = (0,react.useMemo)(function() {
        return isSelected && selectedBorderColor ? colors/* default */.Z[selectedBorderColor] : colors/* default */.Z[tagBorderColor];
    }, [
        isSelected,
        selectedBorderColor,
        tagBorderColor
    ]);
    var checkboxBackgroundColor = (0,react.useMemo)(function() {
        return isSelected && selectedBackgroundColor && colors/* default */.Z[selectedBackgroundColor];
    }, [
        selectedBackgroundColor,
        isSelected
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("checkbox", {
            "custom-check-color": checkColor
        }),
        style: {
            color: checkboxColor,
            borderColor: checkboxBorderColor,
            backgroundColor: checkboxBackgroundColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Check_default()), {})
    });
};
/* harmony default export */ var tag_checkbox = (TagCheckbox);

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tag/square-tag-component.scss.js






var BORDER_COLOR = (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.LIGHT_WORK_OS_IRIS_COLOR_NAME], 0.5);
var StyledSquareTagComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1h5ozrm0"
})("display:flex;flex-direction:column;align-items:center;position:relative;justify-content:center;z-index:", z_index/* TOP_LAYER */.nA, ";cursor:pointer;.background-circle{transition:opacity 100ms ease-in-out;position:absolute;width:80px;height:80px;border-radius:50%;background-color:currentColor;opacity:0%;filter:blur(30px);z-index:", z_index/* ZERO */.xE, ";}.star-image{.star-picture{display:flex;.star-icon{height:40px;}}}.star-text{transition:opacity 100ms ease-in-out;text-align:center;font-size:0.875rem;color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";opacity:85%;padding-top:4px;padding-right:8px;padding-left:8px;}&:active{outline:none;}&.selected,&:hover{.background-circle{opacity:40%;}.star-text{opacity:100%;z-index:", z_index/* LAYER_ONE */.KW, ";}}&.selectable-cluster{justify-content:unset;border:1px solid rgba(255,255,255,0.3);border-radius:8px;margin:8px;padding:8px 8px 16px 8px;height:calc(100% - 16px);transition:border 0.1s ease-in-out;.checkbox{border:1px solid rgba(255,255,255,0.3);transition:all 0.05s ease-in-out;width:20px;height:20px;border-radius:4px;align-self:start;svg{path{fill:transparent;}}}&.selected,&:hover{transition:border 0.1s ease-in-out;border-color:currentColor;.background-circle{opacity:0;}.checkbox{border-color:currentColor;}}&.selected{.checkbox{background-color:currentColor;svg{path{fill:", colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME], ';}}}.checkbox.custom-check-color{svg{path{fill:currentColor;}}}}&.cluster-selected{animation:breatheIn 0.3s linear;}}&.light-theme::after{position:absolute;content:"";background:white;z-index:-1;top:0;bottom:0;left:0;right:0;border-radius:8px;', (0,constants.getComponentShadow)(), "}&.light-theme{border-color:transparent;&.show-border-in-light-theme{&::after{box-shadow:none;}&:not(.selected):not(.hovered){border-color:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";.checkbox{border-color:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";}}}// remove buggy drop-shadow filter behavior in safari in hover interaction and use border instead\n    @media not all and (min-resolution:0.001dpcm){@supports (-webkit-appearance:none){border-color:", BORDER_COLOR, ";&::after{filter:none;}}}.checkbox{border-color:", BORDER_COLOR, ";svg{path{fill:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}.star-text{color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";}&.selected{.checkbox{background-color:currentColor;svg{path{fill:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}}}@keyframes breatheIn{0%{transform:scale(1);}15%{transform:scale(0.995);}20%{transform:scale(0.99);}25%{transform:scale(0.985);}32%{transform:scale(0.98);}50%{transform:scale(0.975);}68%{transform:scale(0.98);}75%{transform:scale(0.985);}80%{transform:scale(0.99);}85%{transform:scale(0.995);}100%{transform:scale(1);}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tag/square-tag-component.js
function square_tag_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            square_tag_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}













var SquareTagComponent = function(props) {
    var CLUSTER_CLICK_ANIMATION_TIME = 300;
    var ref = (0,react.useState)(false), isHovered = ref[0], setIsHovered = ref[1];
    var ref1 = (0,react.useState)(false), wasClusterSelected = ref1[0], setWasClusterSelected = ref1[1];
    var starText = props.starText, starImage = props.starImage, starColorName = props.starColorName, onStarClick = props.onStarClick, tagScheme = props.tagScheme, isSelected = props.isSelected, isDarkTheme = props.isDarkTheme, checkboxScheme = props.checkboxScheme, textScheme = props.textScheme, showBorderInLightTheme = props.showBorderInLightTheme, productType = props.productType;
    var blurTag = function(e) {
        var _e_target_closest, _e_target;
        e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".square-tag-component")) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
    };
    var getCurrentColor = (0,react.useCallback)(function(selectedColor, hoverColor, baseColor) {
        if (isSelected) return colors/* default */.Z[selectedColor];
        return isHovered ? colors/* default */.Z[hoverColor] : colors/* default */.Z[baseColor];
    }, [
        isHovered,
        isSelected
    ]);
    var tagBackgroundColor = (0,react.useMemo)(function() {
        return getCurrentColor(tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor, tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor, null);
    }, [
        getCurrentColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor
    ]);
    var tagTextColor = (0,react.useMemo)(function() {
        return getCurrentColor(textScheme === null || textScheme === void 0 ? void 0 : textScheme.selectedColor, textScheme === null || textScheme === void 0 ? void 0 : textScheme.hoverColor, textScheme === null || textScheme === void 0 ? void 0 : textScheme.color);
    }, [
        getCurrentColor,
        textScheme === null || textScheme === void 0 ? void 0 : textScheme.selectedColor,
        textScheme === null || textScheme === void 0 ? void 0 : textScheme.hoverColor,
        textScheme === null || textScheme === void 0 ? void 0 : textScheme.color
    ]);
    var onClick = function(e) {
        blurTag(e);
        onTagSelection();
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.GRID_TAG_CLICKED, {
            kind: starText,
            info1: productType
        });
        (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).TAG_SELECTED, {
            name: starText
        });
    };
    var onTagSelection = function() {
        setWasClusterSelected(true);
        setTimeout(function() {
            return setWasClusterSelected(false);
        }, CLUSTER_CLICK_ANIMATION_TIME);
        onStarClick && onStarClick();
    };
    var tagBorderColor = (0,react.useMemo)(function() {
        if ((tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor) && isSelected) return colors/* default */.Z[tagScheme.selectedBackgroundColor];
        return (tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor) && isHovered ? colors/* default */.Z[tagScheme.hoverColor] : colors/* default */.Z[tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.borderColor];
    }, [
        isHovered,
        isSelected,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.borderColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.hoverColor,
        tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor
    ]);
    var onMouseOver = function() {
        setIsHovered(true);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.GRID_TAG_HOVERED, {
            kind: starText
        });
    };
    var onMouseLeave = function() {
        return setIsHovered(false);
    };
    var starColor = colors/* default */.Z[tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.selectedBackgroundColor] || colors/* default */.Z[starColorName] || colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSquareTagComponent, {
        className: classnames_default()("square-tag-component", {
            selected: isSelected,
            hovered: isHovered,
            "selectable-cluster": true,
            "light-theme": !isDarkTheme,
            "cluster-selected": wasClusterSelected,
            "show-border-in-light-theme": showBorderInLightTheme
        }),
        style: {
            color: starColor,
            borderColor: tagBorderColor,
            backgroundColor: tagBackgroundColor
        },
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onTagSelection),
        tabIndex: 0,
        role: "checkbox",
        "aria-checked": isSelected,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "background-circle"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_checkbox, _object_spread_props(_object_spread({}, checkboxScheme), {
                isSelected: isSelected,
                tagBorderColor: tagScheme === null || tagScheme === void 0 ? void 0 : tagScheme.borderColor
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "star-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    className: "star-icon",
                    pictureClass: "star-picture",
                    src: starImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "star-text",
                style: {
                    color: tagTextColor
                },
                children: starText
            })
        ]
    });
};
/* harmony default export */ var square_tag_component = (SquareTagComponent);
SquareTagComponent.defaultProps = {
    starText: "Marketing",
    starImage: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/products/product-icons/icons_3d/Marketing_icon_circle.png",
    starColorName: "marketing-red"
};

// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/default-props.js
var default_props = __webpack_require__(62414);
;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tags.scss.js




var StyledSquareTags = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "estbk6w0"
})("margin:auto;display:flex;flex-direction:column;position:relative;align-items:center;justify-content:center;.clusters-stars{margin-top:48px;margin-bottom:56px;display:flex;.star-wrapper{width:140px;position:relative;user-select:none;max-width:170px;min-width:140px;}}.buttons-wrapper{display:flex;align-items:center;.signup-button-wrapper{transform:scale(1);button.signup-button{background-image:var(--background);color:var(--text-color);&:hover{background-image:var(--background-hover);}&:disabled{background-image:var(--background);color:var(--text-color);}}&.cluster-selected{animation:breatheOut 0.3s linear;}.sign-up-combo-with-text-underline{.sign-up-combo-wrapper{.signup-combo-buttons-button{justify-content:center;.secondary-button-wrapper{.secondary-button{.with-underline{background:unset;.secondary-button-text{padding-left:8px;}}}&:hover{.secondary-button{.with-underline{.secondary-button-text{transition:color 0.15 ease-in-out;color:", (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], 0.8), ";}svg path{transition:fill 0.15 ease-in-out;fill:", (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], 0.8), ";}}}}}}}.text-wrapper{margin-top:32px;font-size:0.8125rem;text-align:center;padding-left:3px;}}}}@keyframes breatheOut{0%{transform:scale(1);}15%{transform:scale(1.01);}20%{transform:scale(1.02);}25%{transform:scale(1.03);}32%{transform:scale(1.04);}50%{transform:scale(1.05);}68%{transform:scale(1.04);}75%{transform:scale(1.03);}80%{transform:scale(1.02);}85%{transform:scale(1.01);}100%{transform:scale(1);}}");

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/lodash/shuffle.js
var shuffle = __webpack_require__(69983);
var shuffle_default = /*#__PURE__*/__webpack_require__.n(shuffle);
;// CONCATENATED MODULE: ./segments/desktop/core-components/square-tags/square-tags.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function square_tags_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function square_tags_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function square_tags_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        square_tags_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




















var DARK_THEME_BUTTON_OPACITY = "cc";
var LIGHT_THEME_BUTTON_OPACITY = "ee";
var SIGNUP_BUTTON_ANIMATION_START_TIME = 100;
var SIGNUP_BUTTON_ANIMATION_END_TIME = 400;
var PRESELECTED_TAG_PARAM_NAME = "selectedTag";
var getSelectedTagsInitialState = function(clusters) {
    var initialState = {};
    clusters.forEach(function(sc) {
        return initialState[sc.text] = false;
    });
    return initialState;
};
var SquareTags = function(props) {
    var buttonConfig = props.buttonConfig, clusters = props.clusters, theme = props.theme, secondaryButtonConfig = props.secondaryButtonConfig, tagsWidth = props.tagsWidth, marginTop = props.marginTop, palette = props.palette, showBorderInLightTheme = props.showBorderInLightTheme, randomizeTags = props.randomizeTags, productType = props.productType;
    var ref = (0,react.useState)(getSelectedTagsInitialState(clusters)), selectedTags = ref[0], setSelectedTags = ref[1];
    var ref1 = (0,react.useState)(false), wasClusterSelected = ref1[0], setWasClusterSelected = ref1[1];
    var getSelectedTagFromUrl = function() {
        var selectedTagId = (0,url.getUrlParamValueFromCurrentLocation)(PRESELECTED_TAG_PARAM_NAME);
        if (!selectedTagId) return;
        var selectedTag = clusters.find(function(cluster) {
            return cluster.clusterId === selectedTagId || cluster.useCaseId === selectedTagId;
        });
        return selectedTag;
    };
    var getSelectedTagsMarkedWithInitiallySelected = function() {
        var selectedClusters = clusters.reduce(function(acc, obj) {
            if (obj.initiallySelected) {
                acc[obj.text] = true;
            }
            return acc;
        }, {});
        return selectedClusters;
    };
    var renderedClusters = (0,react.useMemo)(function() {
        return randomizeTags ? shuffle_default()(clusters) : clusters;
    }, [
        clusters,
        randomizeTags
    ]);
    (0,react.useEffect)(function() {
        var selectedTagFromUrl = getSelectedTagFromUrl() || {};
        setSelectedTags(square_tags_object_spread_props(square_tags_object_spread({}, selectedTags, getSelectedTagsMarkedWithInitiallySelected()), (0,_define_property/* default */.Z)({}, selectedTagFromUrl.text, true)));
    }, []);
    var onTagComponentClick = function(star) {
        setSelectedTags(square_tags_object_spread_props(square_tags_object_spread({}, selectedTags), (0,_define_property/* default */.Z)({}, star.text, !selectedTags[star.text])));
        setTimeout(function() {
            return setWasClusterSelected(true);
        }, SIGNUP_BUTTON_ANIMATION_START_TIME);
        setTimeout(function() {
            return setWasClusterSelected(false);
        }, SIGNUP_BUTTON_ANIMATION_END_TIME);
    };
    var renderSquareTags = function() {
        return renderedClusters === null || renderedClusters === void 0 ? void 0 : renderedClusters.map(function(cluster) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "star-wrapper",
                style: {
                    width: tagsWidth
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(square_tag_component, {
                    starText: cluster.text,
                    starImage: cluster.image,
                    tagScheme: palette === null || palette === void 0 ? void 0 : palette.tagScheme,
                    checkboxScheme: palette === null || palette === void 0 ? void 0 : palette.checkboxScheme,
                    textScheme: palette === null || palette === void 0 ? void 0 : palette.textScheme,
                    starColorName: cluster.colorName,
                    onStarClick: function() {
                        return onTagComponentClick(cluster);
                    },
                    isSelected: selectedTags[cluster === null || cluster === void 0 ? void 0 : cluster.text],
                    isSelectableMode: true,
                    isDarkTheme: isDarkTheme,
                    showBorderInLightTheme: showBorderInLightTheme,
                    productType: productType
                })
            }, cluster.text);
        });
    };
    var getSelectedClusters = function() {
        return renderedClusters.filter(function(c) {
            return selectedTags[c.text];
        });
    };
    var isAtLeastOneClusterSelected = function() {
        return Object.values(selectedTags).map(function(star) {
            return star;
        }).reduce(function(acc, s) {
            return acc || s;
        }, false);
    };
    var getButtonColorBySelectedClusters = function(isDarkTheme, isHover) {
        var _buttonColor = buttonConfig.buttonColor, buttonColor = _buttonColor === void 0 ? color_consts.GRADIANT_WORKOS_IRIS_COLOR_NAME : _buttonColor, removeGradient = buttonConfig.removeGradient;
        if (removeGradient) return colors/* default */.Z[buttonColor];
        var OPACITY_VALUE = isDarkTheme ? DARK_THEME_BUTTON_OPACITY : LIGHT_THEME_BUTTON_OPACITY;
        var selectedClusters = getSelectedClusters();
        if (!isAtLeastOneClusterSelected || selectedClusters.length === 0) {
            return isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[buttonColor]) : colors/* default */.Z[buttonColor];
        }
        // if only 1 cluster was selected, fill the button with a gradient built of the same color
        if (selectedClusters.length === 1) {
            var colorName = selectedClusters[0].colorName;
            var color = isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[colorName]) : colors/* default */.Z[colorName];
            return "linear-gradient(90deg, ".concat(color).concat(OPACITY_VALUE, " 0%, ").concat(color).concat(OPACITY_VALUE, " 100%)");
        }
        var colorsString = "";
        var chunkSize = 100 / (selectedClusters.length - 1);
        // building the linear gradient string
        // for example, if 3 clusters are selected, the linear gradient stop locations should be 0%, 50% and 100%
        selectedClusters.forEach(function(selectedStarsItem, index) {
            // add separator in every chunk instead of last chunk
            var separator = index === selectedClusters.length - 1 ? "" : ", ";
            var starItemColor = isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[selectedStarsItem.colorName]) : colors/* default */.Z[selectedStarsItem.colorName];
            colorsString += "".concat(starItemColor).concat(OPACITY_VALUE, " ").concat(chunkSize * index, "%").concat(separator);
        });
        return "linear-gradient(90deg, ".concat(colorsString, ")");
    };
    var getButtonTextColor = function() {
        var buttonColor = buttonConfig.buttonColor, removeGradient = buttonConfig.removeGradient;
        if (removeGradient) {
            return buttonColor === color_consts.WHITE_COLOR_NAME ? colors/* default */.Z[color_consts.BRAND_BLACK_BACKGROUND_COLOR] : colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
        }
        var selectedClusters = getSelectedClusters();
        if (buttonColor === color_consts.WHITE_COLOR_NAME && selectedClusters.length === 0) {
            return colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME];
        }
        return colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
    };
    var saveClustersOnSignup = function() {
        var selectedClusters = getSelectedClusters();
        var clustersToUpdate = selectedClusters.map(function(cluster) {
            var clusterId = cluster.clusterId, useCaseId = cluster.useCaseId;
            var res = [];
            if (clusterId) {
                res.push({
                    clusterId: clusterId,
                    clusterType: types.CLUSTER_TYPE
                });
            }
            if (useCaseId) {
                var extraData = clusterId ? {
                    parent_cluster_id: clusterId
                } : {};
                res.push({
                    clusterId: useCaseId,
                    clusterType: types.USE_CASE_TYPE,
                    extraData: extraData
                });
            }
            return res;
        });
        var flattenedArray = clustersToUpdate.flat();
        if (flattenedArray.length > 0) {
            // fire each cluster id as an event, so filtering can be fully customized on Hotjar side
            (0,hotjar_service/* fireHotjarEvents */.no)(flattenedArray.map(function(cluster) {
                return "tag_selected_".concat(cluster.clusterType, "_").concat(cluster.clusterId);
            }));
            (0,clusters_service/* updateUserClustersListWithMultipleClusters */.aC)(flattenedArray, constants_clusters.HP_TAGS_SELECTION);
        }
    };
    var isDarkTheme = (0,react.useMemo)(function() {
        return [
            segments_service/* SPACE_BLUE_GRADIANT_THEME_ID */.I7,
            segments_service/* BRAND_DARK_COLOR_THEME_ID */.qp
        ].includes(theme) || !(0,utils_service.isEmpty)(palette);
    }, [
        palette,
        theme
    ]);
    var additionalSignUpButtonConfig = {
        beforeSubmitCallback: saveClustersOnSignup,
        displayedOnDarkTheme: isDarkTheme
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSquareTags, {
        className: "square-tags",
        style: {
            "--background": getButtonColorBySelectedClusters(isDarkTheme),
            "--background-hover": getButtonColorBySelectedClusters(isDarkTheme, true),
            "--text-color": getButtonTextColor()
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "clusters-stars",
                role: "group",
                style: {
                    marginTop: marginTop
                },
                children: renderSquareTags()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "buttons-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("signup-button-wrapper", {
                            "cluster-selected": wasClusterSelected
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, square_tags_object_spread({}, buttonConfig, additionalSignUpButtonConfig))
                    }),
                    secondaryButtonConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)(secondary_button/* default */.Z, square_tags_object_spread({}, secondaryButtonConfig))
                ]
            })
        ]
    });
};
SquareTags.defaultProps = default_props/* default */.Z;
/* harmony default export */ var square_tags = ((0,generic_config_context/* withGenericConfig */.P)(SquareTags));


/***/ })

}]);